import React, { Component } from 'react';
import { connect } from '@common/components/base.component';
import Loader from '@common/components/loader/loader';
import Header from '@common/components/headerLayout/headerLayout.component';
import { Tooltip as KendoTooltip } from '@progress/kendo-react-tooltip';
import * as commonActionType from '@common/store/common/common.actionsType';
import Sidemenu from '@common/components/sidemenu/sidemenu';
import { Layout, Drawer } from 'antd';

import navbarActions from '@common/store/navbar/navbar.actions';
import navbarSelectors from '@common/store/navbar/navbar.selectors';

import WindowManagerComponent from '@common/components/dialog/windowManager.component';
import windowSelector from '@common/store/window/window.selectors';
import windowActions from '@common/store/window/window.actions';

import layoutActions from '@common/store/layout/layout.actions';
import layoutSelectors from '@common/store/layout/layout.selectors';

class LayoutWithMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      route: '',
    };
  }

  componentDidMount() {
    PubSub.subscribe(commonActionType.REDIRECT, this.onRedirect.bind(this));
    this.setState({ route: this.props.routerManager.currentUrl });
  }

  onRedirect(action, route) {
    this.props.routerManager.redirect(route);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    let { routerManager } = prevProps;
    if (routerManager.currentUrl != this.state.route) {
      this.setState({ route: routerManager.currentUrl });
      let { resetWindow } = this.props.windowActions;
      resetWindow();
    }
  }

  render() {
    const { menuCollapse } = this.props.navbarSelectors;
    // Estado global que contém todos os Window's criados na página
    let { window } = this.props.windowSelector;

    // Ações para controlar a visibilidade do Window de cada componente
    let { removeWindow } = this.props.windowActions;

    const { layout } = this.props.layoutSelectors;
    const { showTooltip } = layout;

    return (
      <KendoTooltip open={showTooltip} position="top" anchorElement="target" openDelay={0}>
        <Loader />
        <Layout style={{ minHeight: '100vh' }}>
          <Header />
          <WindowManagerComponent component={window} closeWindow={removeWindow} />
          <Layout>
            <Layout>
              <Drawer
                width={'256px'}
                placement="left"
                closable={true}
                onClose={this.props.navbarActions.toggleMenu}
                visible={this.props.navbarSelectors.menuCollapse.toggleMenu}
                keyboard={true}
              >
                <Sidemenu />
              </Drawer>
              <Layout.Content style={{ marginTop: '64px' }}>
                <div className={'content-container'}>{this.props.children}</div>
              </Layout.Content>
            </Layout>
          </Layout>
        </Layout>
      </KendoTooltip>
    );
  }
}

export default connect({
  selectors: {
    navbarSelectors,
    windowSelector,
    layoutSelectors,
  },
  actions: {
    navbarActions,
    windowActions,
    layoutActions,
  },
})(LayoutWithMenu);
